import * as React from 'react';
import { Segment, Tab, TabPane } from 'semantic-ui-react';

interface IBPTabPaneProps {
    loading?: boolean;
    children: React.ReactNode
}

export const BPTabPane: React.FunctionComponent<IBPTabPaneProps> = (props) => {
    return <TabPane {...props} className="no-padding" attached={false} as={Segment} basic>{props.children}</TabPane>;
};
